import { render, staticRenderFns } from "./UpdateMatchQuestionPackageDialog.vue?vue&type=template&id=15d9b3d6"
import script from "./UpdateMatchQuestionPackageDialog.vue?vue&type=script&lang=js"
export * from "./UpdateMatchQuestionPackageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports